/* eslint-disable no-console */
import React from 'react';

import { Box } from '@mui/material';

import BookingCancelledToggle from './BookingCancelledToggle';
import RefundAmount from './RefundAmount';
import RefundVendorAgrees from './RefundVendorAgrees';
import TourCancellationWarning from './TourCancellationWarning';

export default function CustomRefundVariant(props) {
  const shouldDisallowTourCancellation = props.refund.is_tour && props.refund.is_tour_with_active_optional_extras;

  return (
    <Box id="CustomRefundVariant">
      <RefundVendorAgrees
        handleValueChange={props.handleValueChange}
        refund_vendor_agrees_to={props.refund.refund_vendor_agrees_to}
        refund={props.refund}
      />
      <RefundAmount
        tmpValue={props.tmpValue}
        handleTmpChange={props.handleTmpChange}
        itemRefund={props.itemRefund}
        itemRefundOriginal={props.itemRefundOriginal}
        refund={props.refund}
      />
      <TourCancellationWarning shouldDisallowTourCancellation={shouldDisallowTourCancellation} />
      {!shouldDisallowTourCancellation && !props.refund.is_subscription && (
        <BookingCancelledToggle
          handleFlagChange={props.handleFlagChange}
          mark_cancelled={props.refund.mark_cancelled}
        />
      )}
    </Box>
  );
}
